module.exports = __webpack_public_path__ + "static/media/occasions-deliciousness.f10ff9b1.jpg";